import React, { useRef, useEffect } from "react"
import Title from "../Shared/Title/Title"
import * as styles from "./recipeProductCard.module.scss"
import { GatsbyImage } from "gatsby-plugin-image"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper";
import { useLocalPath } from "../hooks/useLocalPath"
import { Link } from "gatsby"
import { useLocale } from "../hooks/useLocale"
const RecipeProductCard = ({ gridItems }) => {
  const { products, title, backgroundColor } = gridItems

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-pagination-color", "#ff5005")
    document.getElementsByClassName('swiper-pagination-bullets')[0]?.classList.add(styles.pagination)
    return () => document.getElementsByClassName('swiper-pagination-bullets')[0]?.classList.remove(styles.pagination)
  })

  const locale = useLocale()

  const swiperRef = useRef()
  const option = {
    spaceBetween: 20,
    grabCursor: true,
    loop: products?.length > 1 ? true : false,
    keyboard: {
      enabled: true,
    },
    pagination: {
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 320px
      220: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      // when window width is >= 640px
      767: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlide: true
      },
    },
    modules: [Pagination],
    slidesPerView: 3,
  }

  const ratings = (locale, sku, adimoTouchpointIds) => {
    switch (locale) {
      case 'en-CA':
        return (
          <>
            <div className={styles.rating}>
              <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
            </div>
            <button className={styles.buyButton}>
              Buy Online
            </button>
          </>
        )
      case 'fr-CA':
        return (
          <>
            <div className={styles.rating}>
              <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
            </div>
            <button className={styles.buyButton}>
              ACHETER
            </button>
          </>

        )
      default:
        return (
          <>
            <div className={styles.rating}>
              <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
            </div>
            <div className={styles.btn}>
              <AdimoBuyNowBtn touchpointIds={adimoTouchpointIds} />
            </div>
          </>
        )
    }
  }
  return (
    <div className="container" style={{ background: backgroundColor }}>
      <div className={`container-lg ${styles.wrapper}`}>
        <h2 className={styles.title}>
          <Title title={title} />
        </h2>
        <div className={styles.cardContainer}>
          <Swiper
            ref={swiperRef}
            {...option}
            className={styles.swiperProducts}
          >
            {products &&
              products.map((card: any, id: number) => {
                const { slug, thumbnailImage, thumbnailTitle, sku, priceFirstId, wtbFirstId } = card
                const adimoTouchpointIds = [priceFirstId, wtbFirstId].filter(Boolean).join(',')

                return (
                  <SwiperSlide key={id}>
                    <Link to={useLocalPath(slug)}>
                        <div className={styles.cardWrapper}>
                          <div className={styles.card}>
                            <div className={styles.cardImage}>
                              <GatsbyImage
                                image={thumbnailImage.gatsbyImageData}
                                alt={`${thumbnailImage.title} image`}
                                loading="lazy"
                              />
                            </div>
                            <div>
                              <div className={styles.cardTitle}>
                                {thumbnailTitle}
                              </div>
                              {ratings(locale, sku, adimoTouchpointIds)}
                              {/* <button className="red-transparent-button">
                                Buy Online
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </Link>
                  </SwiperSlide>
                )
              })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default RecipeProductCard

const AdimoBuyNowBtn = ({ touchpointIds }) => {
  return (
    <button disabled={!touchpointIds} className={`adimo-multi-touchpoint ${styles.buyButton}`} data-type="multi-touchpoint-lightbox" data-static-touchpoint-identifiers={touchpointIds}>Buy Now</button>
  )
}